import DeleteRounded from "@mui/icons-material/DeleteRounded";
import { Box, IconButton, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import { DataGrid } from "@mui/x-data-grid";
import moment from "moment";
import { useEffect, useState } from "react";
import { GlobalState } from "context/GlobalContext";
import { allPOItemAssoc, poItemStyleAssoc, statusOptions } from "data/pimData";
import FobPoCreationPopup from "../CreatePoTab/FobPoCreationPopup";
import { deletePo, getAllPo } from "../../fobPoApi";

const colStyle = {
	headerAlign: "center",
	align: "center",
};

const AllPoTab = () => {
	const { setSnackBar, snackBar, setSnackBarOpen, setLoadingOpen } = GlobalState();
	const [allPO, setAllPO] = useState([]);
	const [selectedPO, setSelectedPO] = useState();
	const [modalOpen, setModalOpen] = useState(false);
	const [selectedPOStyles, setSelectedPOStyles] = useState([]);

	const fetch = async () => {
		setLoadingOpen(true);
		try {
			const rows = await getAllPo();
			setAllPO(rows || []);
		} catch (error) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: "Server Error",
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
		} finally {
			setLoadingOpen(false);
		}
	};

	useEffect(() => {
		fetch();
	}, []);

	const POObjToStyleArr = (po) => {
		const poItems = po?.[allPOItemAssoc] || [];
		const map = poItems.reduce((acc, poItem) => {
			if (!acc[poItem?.style_id]) {
				acc[poItem.style_id] = {
					id: poItem.style_id,
					style_name: poItem?.[poItemStyleAssoc]?.style_name,
					size_type: poItem?.[poItemStyleAssoc]?.size_type,
					styleColorBuying: poItem?.[poItemStyleAssoc]?.styleColorBuying || [],
				};
			}
			return acc;
		}, {});
		return Object.values(map);
	};

	const deleteFobPo = async (id) => {
		setLoadingOpen(true);
		try {
			await deletePo(id);
			await fetch();
		} catch (error) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: "Server Error",
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
		} finally {
			setLoadingOpen(false);
		}
	};

	const deleteSizeClick = (row, e) => {
		e.stopPropagation();
		deleteFobPo(row.id);
	};

	const POTableColumns = [
		{ field: "order_no", headerName: "Order NO", width: 140, ...colStyle },
		{
			field: "date",
			headerName: "Created Date",
			width: 140,
			...colStyle,
			valueGetter: (value) => moment(value).format("DD/MM/YYYY"),
		},
		{ field: "owner_site", headerName: "Wearhouse", width: 120, ...colStyle },
		{ field: "channel", headerName: "Channel", width: 120, ...colStyle },
		{ field: "vendor_name", headerName: "Vendor Name", width: 160, ...colStyle },
		{ field: "currency", headerName: "Currency", width: 100, ...colStyle },
		{ field: "purchase_type", headerName: "Purchase Type", width: 120, ...colStyle },
		{
			field: "delivery_date",
			headerName: "Delivery Date",
			width: 140,
			...colStyle,
			valueGetter: (value) => moment(value).format("DD/MM/YYYY"),
		},
		{ field: "bought_qty", headerName: "Bought Qty", width: 110, ...colStyle },
		{ field: "status", headerName: "Status", width: 120, ...colStyle },
		{
			field: "stage",
			headerName: "Stage",
			width: 120,
			...colStyle,
			renderCell: ({ row }) => {
				const published = row?.is_published;
				const status = published ? statusOptions.PUBLISHED.key : statusOptions.DRAFTED.key;
				return (
					<Typography color={published ? "success.main" : "text.primary"} variant="subtitle2">
						{status}
					</Typography>
				);
			},
		},
		{
			field: "action",
			headerName: "Action",
			width: 90,
			...colStyle,
			renderCell: (params) => (
				<IconButton disabled={params.row?.is_published} onClick={(e) => deleteSizeClick(params.row, e)}>
					<DeleteRounded />
				</IconButton>
			),
		},
	];

	const handlePOSelect = (po) => {
		setSelectedPO(po);
		setSelectedPOStyles(POObjToStyleArr(po));
		setModalOpen(true);
	};

	return (
		<Box>
			<DataGrid
				rows={allPO}
				columns={POTableColumns}
				getRowId={(row) => row.id}
				sx={{
					minHeight: 350,
					maxHeight: 430,
					border: "none",
					"& .MuiDataGrid-row": {
						cursor: "pointer",
						border: "none",
					},
					"& .MuiDataGrid-cell": {
						display: "flex",
						alignItems: "center",
					},
					"& .MuiDataGrid-columnHeader": {
						cursor: "pointer",
					},
					"& .MuiDataGrid-columnHeaders": {
						background: grey[300],
						border: "none",
						borderRadius: 1,
					},
				}}
				columnHeaderHeight={35}
				rowHeight={50}
				onRowClick={(params) => handlePOSelect(params.row)}
				initialState={{
					pagination: {
						paginationModel: { pageSize: 10 },
					},
				}}
				pageSizeOptions={[10, 50]}
				disableRowSelectionOnClick
			/>
			{modalOpen && selectedPO && selectedPOStyles && (
				<FobPoCreationPopup
					edit
					modalOpen={modalOpen}
					handleCloseModal={() => setModalOpen(false)}
					channel={selectedPO?.channel}
					warehouse={selectedPO?.warehouse || selectedPO?.owner_site}
					selectedStyles={selectedPOStyles}
					selectedPO={selectedPO}
					refreshTable={fetch}
				/>
			)}
		</Box>
	);
};

export default AllPoTab;
